export const TermSeparator = '__';
export const ValueSeparator = '~';
export const GroupSeparator = '*';
export const KeySeparator = '_';
